<!-- src/components/Ajuda/Montador/sidebar/SidebarSection.vue -->
<script setup>
import { ref, watch, onMounted } from 'vue'

const props = defineProps({
  idKey:     { type: String, required: true }, // chave única p/ persistência
  title:     { type: String, required: true },
  startOpen: { type: Boolean, default: true },
  badge:     { type: String, default: '' },
})

const isOpen = ref(!!props.startOpen)

onMounted(() => {
  const k = `montador.sidebar.${props.idKey}`
  const v = localStorage.getItem(k)
  if (v !== null) isOpen.value = (v === '1')
})

watch(isOpen, v => {
  const k = `montador.sidebar.${props.idKey}`
  localStorage.setItem(k, v ? '1' : '0')
})

function toggle() { isOpen.value = !isOpen.value }
function onKey(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle() } }
</script>

<template>
  <div class="section section-accordion">
    <div class="section-header" role="button" tabindex="0" @click="toggle" @keydown="onKey">
      <div class="title-wrap">
        <span class="section-title">{{ title }}</span>
        <span v-if="badge" class="section-badge">{{ badge }}</span>
      </div>
      <!-- Setinha própria (sem dependências) -->
      <span class="chev">{{ isOpen ? '▴' : '▾' }}</span>
    </div>

    <div v-show="isOpen" class="section-body">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.section-accordion { border-top: 1px dashed #334; padding-top: 8px; margin-top: 12px; }
.section-header { display:flex; align-items:center; justify-content:space-between; cursor:pointer; padding: 4px 0; }
.title-wrap { display:flex; align-items:center; gap:8px; }
.section-title  { font-weight: 700; letter-spacing:.2px; color: #cfe2ff; font-size: 13px; }
.section-badge  { background:#1a2a4a; border:1px solid #2a3a5a; color:#e8eefc; border-radius:999px; padding:2px 8px; font-size:11px; }
.chev { opacity:.8; } .section-header:hover .chev { opacity:1; }
.section-body { padding-top: 8px; }
</style>
